import React from 'react';
import { StarIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/eGJa3D669w1J2HjT7j2Vvt/gpt-mk.png';
export function Hero() {
  return <header className="hero-radial relative w-full overflow-hidden bg-zinc-950" data-id="element-95">
      <div className="mx-auto grid max-w-6xl items-center gap-8 px-4 py-12 sm:gap-10 sm:py-24 lg:grid-cols-2" data-id="element-96">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-97">
          <p className="mb-4 text-xs font-bold uppercase tracking-[0.18em] text-orange-500 sm:text-sm" data-id="element-98">
            El fin de los lanzamientos lentos, caros y frustrantes...
          </p>
          <h1 className="font-display text-3xl leading-[1.05] text-white sm:text-4xl lg:text-5xl" data-id="element-99">
            Cómo Lanzar un Negocio Digital{' '}
            <span className="text-glow-orange text-orange-500" data-id="element-100">
              Rentable en 7 Días
            </span>{' '}
            o Menos usando un Ecosistema de{' '}
            <span className="text-amber-400" data-id="element-101">8 GPTs Autónomos</span>...
          </h1>
          <p className="mt-6 max-w-xl text-base text-zinc-400 sm:text-lg" data-id="element-102">
            Sin saber de tecnología, sin equipo de marketing y sin escribir una
            sola palabra de copy. El sistema que hace el trabajo de una agencia
            de <span className="font-semibold text-zinc-200" data-id="element-103">$5,000</span> por
            el precio de una cena.
          </p>
          <div className="mt-8 hidden lg:block" data-id="element-104">
            <CtaButton size="lg" className="w-full sm:w-auto" data-id="element-105">
              ¡Sí! Quiero mi máquina de lanzamiento ahora
            </CtaButton>
          </div>
          <div className="mt-6 flex flex-wrap items-center gap-2" data-id="element-106">
            <span className="flex" aria-hidden="true" data-id="element-107">
              {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-amber-400 text-amber-400" data-id="element-108" />)}
            </span>
            <span className="text-sm text-zinc-300" data-id="element-109">
              <span className="font-semibold text-white" data-id="element-110">
                Más de 1,200 lanzadores
              </span>{' '}
              activos este mes
            </span>
          </div>
        </motion.div>

        <motion.div className="relative" initial={{
        opacity: 0,
        scale: 0.92
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.15,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-111">
          <div className="pointer-events-none absolute inset-0 -z-10 rounded-3xl bg-orange-500/10 blur-3xl" data-id="element-112" />
          <img src={PRODUCT_IMG} alt="Launch Machine AI — paquete de 8 expertos de IA con derechos de reventa, mostrado en tablet, móvil y libro." className="mx-auto w-full max-w-md rounded-2xl" loading="eager" data-id="element-113" />
          <div className="mt-6 flex justify-center lg:hidden" data-id="element-114">
            <CtaButton size="lg" className="w-full max-w-md" data-id="element-115">
              ¡Sí! Quiero mi máquina de lanzamiento ahora
            </CtaButton>
          </div>
        </motion.div>
      </div>
    </header>;
}